<template>
  <!-- 顶部通栏 -->
  <AppTopnav />
  <!-- 吸顶头部 -->
  <AppHeaderSticky />
  <!-- 头部组件 -->
  <AppHeader />
  <main class="app-body">
    <!-- 二级路由 -->
    <router-view></router-view>
  </main>
  <AppFooter />
</template>

<script>
import AppTopnav from "@/components/app-topnav";
import AppHeader from "@/components/app-header";
import AppFooter from "@/components/app-footer";
import AppHeaderSticky from "@/components/app-header-sticky";
import { useStore } from "vuex";
export default {
  name: "sh-Layout",
  components: {
    AppTopnav,
    AppHeader,
    AppFooter,
    AppHeaderSticky,
  },
  //获取全部专业分类
  setup() {
    const store = useStore();
    store.dispatch("category/getList");
  },
};
</script>

<style scoped lang="less">
.app-body {
}
</style>
